import { useUser } from '../../authentication';
import { switchOrg } from '../../org';

export const useSwitchOrg = () => {
  const { user, refreshUser } = useUser();

  const switchToOrg = (orgId: string): Promise<void> => {
    if (!user) return Promise.reject(new Error('No user'));

    if (orgId === user.lastSelectedAccount) {
      return Promise.resolve();
    }

    return switchOrg(user.userId, orgId)
      .then(() => refreshUser())
      .then(() => undefined);
  };

  return { switchToOrg };
};
